<div class="d-flex justify-content-center">
  <div class="d-flex align-items-center change-story ">
    <img class="mx-auto cursor-pointer" src="assets/images/previous-slide.png" (click)="leftGesture()">
  </div>
  <div class="story-container">
    <div *ngIf="stories && stories.list &&  stories?.list?.length > 0 && stories.list[activeIndex] && loadingState === 'SUCCESS'" class="stories position-relative">
      <app-story-main *ngIf="currentPlaying" [storyProgressPercentage]="storyProgressPercentage" (headerRedirect)="profileHeaderRedirection()" (profileRedirectEmit)="profileRedirect($event)" [stories]="stories" [autoStart]="autoStart" (emitClose)="closeStory()" [currentPlaying]="currentPlaying" (emitDuration)="emitVideoDuration($event)" (emitReaction)="reactionLog($event)" [longPressedEvent]="longPressedEvent" [createdOn]="stories.list[activeIndex]?.publishOn" [storiesChange]="storiesChangeEvent" [fileType]="stories.list[activeIndex].fileType ? stories.list[activeIndex].fileType : STORY_TYPES.TEXT " [showVolume]="stories.list[activeIndex]?.fileType === STORY_TYPES.VIDEO" [speciality]="stories.speciality" [story]="stories.list[activeIndex]"  [storyViewList]="storyViewList" [storyType]="stories.list[activeIndex].storyType" [isMuted]="audioStatus"  [customComponent]="customComponent"
        [profileImage]="stories.fileCode" [type]="stories.type" [viewListByDefault]="viewListByDefault" [headerDropdownList]="headerDropdownList" (emitRequest)="sendRequest()"
        (emitAction)="doAction($event)" (lockScreen)="disableStoryChangeGesture($event)" 
        (emitViewListClicked)="viewListClicked($event)" [viewCount]="stories.list[activeIndex]?.impressionCount" [reactionCount]="stories.list[activeIndex]?.reactionCount" (emitViewListScrolled)="viewListScrolled()" (emitToggleProgressCounter)="toggleProgressCounter($event)"
        [isMe]="stories.type === 'ME' ? true : false "  [userType]="stories.type" (deepLinkRedirectEmit)="deepLinkRedirect($event)" (emitToggleMuteStatus)="audioStatus = $event"
        (emitCtaTarget)="onEmitCtaTarget($event)" [activeIndex]="activeIndex" [fullName]="stories.fullName" [channelId]="stories.channelId" (emitOnMeta)="metaAction($event)">
      </app-story-main>
    
      <app-multi-gestures *ngIf="currentPlaying && autoStart" (leftGesture)="leftGesture()" (rightGesture)="rightGesture()"
        (longGesture)="longGesture()">
      </app-multi-gestures>
    
      <!-- <app-thumbnail-views *ngIf="!currentPlaying" [story]="stories">
      </app-thumbnail-views> -->
    </div>
    <div *ngIf="loadingState === 'PENDING'" class="stories position-relative no-available">
      <div class="story-header">
        <div class="my-3">
          <app-story-progress [activeIndex]="0" [loadingState]="true"
          ></app-story-progress>
        </div>
        <div class="mb-4">
          <app-profile-basic-header [loadingState]="true" (emitClose)="closeStory()">
        </app-profile-basic-header>
        </div>
      </div>
      <div class="w-100">
        <app-no-info-available [loadingState]="'loadingState'"  noInfoSrc="assets/images/unavailable.svg" [noInfoType]="NO_STORIES_TYPE.SINGLE_THUMBNAIL"
        [timer]="defaultDuration" [noInfoHeading]="mls.languageText.no_stories.key3"
        [noInfoParagraph]="mls.languageText.no_stories.key4" [noInfoButtonText]="mls.languageText.no_stories.key5" (onGoBack)="goBack()" (onToNext)="rightGesture()">
      </app-no-info-available>
      </div>
    <div class="d-flex story-footer  justify-content-between px-3">
      <div class=" load-button w-50 mr-2">
        <button class="w-100  mr-2 button-section "></button>
        </div>
      <div class="load-button">
        <button class="button-section w-100"></button>
      </div>
    </div>
    <app-multi-gestures *ngIf="currentPlaying && autoStart" (leftGesture)="leftGesture()"
      (rightGesture)="rightGesture()">
    </app-multi-gestures>
    </div>
    <div *ngIf="loadingState === 'SUCCESS' && stories && stories?.list?.length === 0" class="stories position-relative d-flex align-items-center bg-grey" style="border-radius: 8px;">
      <div class="story-header">
        <div class="my-3">
          <app-story-progress [activeIndex]="0" [loadingState]="true"
          ></app-story-progress>
        </div>
        <div class="mr-4 mt-1 cursor-pointer flex-shrink-0 d-block d-md-none" style="text-align: right;" (click)="closeStory()">
          <img width="32px" src="assets/images/cross.svg" alt="cross">
        </div>
      </div>
      <div class="w-100">
        <app-no-info-available [loadingState]="loadingState"  noInfoSrc="assets/images/unavailable.svg" [noInfoType]="NO_STORIES_TYPE.SINGLE_THUMBNAIL"
        [timer]="defaultDuration" [noInfoHeading]="mls.languageText.no_stories.key3"
        [noInfoParagraph]="mls.languageText.no_stories.key4" [noInfoButtonText]="mls.languageText.no_stories.key5" (onGoBack)="goBack()" (onToNext)="rightGesture()">
      </app-no-info-available>
      </div>
    <app-multi-gestures *ngIf="currentPlaying && autoStart" (leftGesture)="leftGesture()"
      (rightGesture)="rightGesture()">
    </app-multi-gestures>
    </div>
  </div>
  <div class="d-flex align-items-center change-story ">
    <img class="mx-auto cursor-pointer"src="assets/images/next-slide.png" (click)="rightGesture()">
  </div>
</div>
<app-delete-modal *ngIf="currentPlaying && autoStart && isStoryDeleteModal"
  [headingText]="mls.languageText?.stories_modal.key1+'?'" [paragraphText]="mls.languageText?.stories_modal.key2+'.'"
  [cancelButtonText]="mls.languageText?.stories_modal.key3" [deleteButtonText]="mls.languageText?.stories_modal.key4"
  [isDeleteModal]="isStoryDeleteModal" (emitOnHidden)="isStoryDeleteModal = false" (emitOnDelete)="emitStoryDelete()">
</app-delete-modal>